<template>
  <div class="subproperty-input">
    <el-form
      :label-position="labelPosition"
      :label-width="labelWidthForm"
      :model="model"
      :rules="rules"
      class="form"
      ref="form"
      v-if="model"
    >
      <!-- Subtitle -->
      <h2 
        v-if="!isMonoSubproperty"
        class="app-content-subtitle"
      >
        <app-i18n code="entities.subproperty.form.subtitle.information" />
      </h2>

      <!-- Section 1 -->
      <el-row :gutter="10"
        v-if="!isMonoSubproperty"
      >
        <!-- Country -->
        <el-col :lg="6" :md="12" :sm="24">
          <el-form-item
            :label="fields.country.label"
            :prop="fields.country.name"
            :required="fields.country.required"
          >
            <el-select
              v-model="model[fields.country.name]"
              :disabled="disableCountry"
              :placeholder="i18n('entities.subproperty.placeholders.country')"
            >
              <i class="icon-location" slot="prefix"></i>
              <el-option
                v-for="option in supportedCountries"
                :key="option.id"
                :label="option.label"
                :value="option.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- Region -->
        <el-col :lg="6" :md="12" :sm="24" v-if="showRegion">
          <el-form-item
            :label="fields.region.label"
            :prop="fields.region.name"
            :required="fields.region.required"
          >
            <el-input
              v-model="model[fields.region.name]"
              prefix-icon="icon-location"
              :placeholder="i18n('entities.subproperty.placeholders.region')"
              ref="focus"
            />
          </el-form-item>
        </el-col>

        <!-- Name -->
        <el-col :lg="12" :md="24" :sm="24">
          <el-form-item
            :label="!isPropertyNBA ? fields.name.label : i18n('entities.base.fields.name')"
            :prop="fields.name.name"
            :required="fields.name.required"
          >
            <el-input
              v-model="model[fields.name.name]"
              prefix-icon="icon-cup"
              :placeholder="!isPropertyNBA ? i18n('entities.subproperty.placeholders.name') : i18n('entities.base.fields.name')"
              ref="focus"
            />
          </el-form-item>
        </el-col>
        <el-col :offset="12" />
      </el-row>

      <!-- Separator -->
      <div 
        v-if="!isMonoSubproperty"
        class="app-content-separator" 
      />

      <!-- Subtitle -->
      <h2 
        v-if="!isMonoSubproperty"
        class="app-content-subtitle subproperty-form-page__subtitle"
      >
        <app-i18n code="entities.subproperty.form.subtitle.management" />
      </h2>

      <!-- Description -->
      <h3
        v-if="!isMonoSubproperty" 
        class="app-content-description subproperty-form-page__description"
      >
        <app-i18n code="entities.subproperty.form.description.email" />
      </h3>

      <!-- Section 2 -->
      <el-row :gutter="10"
        v-if="!isMonoSubproperty"
      >
        <!-- Emails -->
        <el-col :lg="24" :md="24" :sm="24">
          <el-form-item
            :label="fields.emails.label"
            :prop="fields.emails.name"
            :required="fields.emails.required"
          >
            <emails-input
              v-model="model[fields.emails.name]"
              prefix-icon="icon-mail"
              :placeholder="i18n('entities.subproperty.placeholders.email')"
            ></emails-input>
          </el-form-item>
        </el-col>
        <el-col :offset="12" />

        <!-- Status -->
        <el-col :lg="12" :md="24" :sm="24">
          <el-form-item
            v-if="isEditing"
            :label="fields.status.label"
            :prop="fields.status.name"
            :required="fields.status.required"
          >
            <el-select
              v-model="model[fields.status.name]"
              :placeholder="i18n('entities.subproperty.placeholders.email')"
            >
              <i :class="prefixStatus" slot="prefix"></i>
              <el-option
                v-for="option in fields.status.options"
                :key="option.id"
                :label="option.label"
                :value="option.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- Owqlo fees -->
      <el-row :gutter="10" v-if="enableOwqloFees">
        <el-col :lg="6" :md="8" :sm="12">
          <el-form-item
            :label="fields.owqloFeeFixed.label"
            :prop="fields.owqloFeeFixed.name"
            :required="fields.owqloFeeFixed.required"
          >
            <el-input
              prefix-icon="icon-card"
              :placeholder="fields.owqloFeeFixed.label"
              ref="focus"
              type="number"
              v-model.number="model[fields.owqloFeeFixed.name]"
            />
          </el-form-item>
        </el-col>

        <el-col :lg="5" :md="8" :sm="12">
          <el-form-item
            :label="fields.owqloFeePercentage.label"
            :prop="fields.owqloFeePercentage.name"
            :required="fields.owqloFeePercentage.required"
          >
            <el-input
              prefix-icon="icon-percent"
              :placeholder="fields.owqloFeePercentage.label"
              ref="focus"
              type="number"
              v-model.number="model[fields.owqloFeePercentage.name]"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <!-- Separator -->
      <div class="app-content-separator" />

      <!-- Subtitle -->
      <h2 class="app-content-subtitle">
        <app-i18n code="entities.subproperty.form.subtitle.settings" />
      </h2>

      <!-- Settings -->
      <el-row :gutter="10">
        <!-- Birthdate type -->
        <el-col :lg="12" :md="24" :sm="24">
          <el-form-item
            :label=" fields.birthdateType.label"
            :prop="fields.birthdateType.name"
            :required="fields.birthdateType.required"
          >
            <el-select
              :placeholder="i18n('common.select.placeholder')"
              v-model="model[fields.birthdateType.name]"
              :disabled="isEditing"
            >
              <i slot="prefix" class="icon-cup" />
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.birthdateType.options"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- Date format -->        
        <el-col :lg="6" :md="12" :sm="12">
          <el-form-item
            :label="fields.dateFormat.label"
            :prop="fields.dateFormat.name"
            :required="fields.dateFormat.required"
          >
            <el-select
              :placeholder="i18n('common.select.placeholder')"
              v-model="model[fields.dateFormat.name]"
            >
              <i slot="prefix" class="icon-calendar" />
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.dateFormat.options"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!-- Time format -->
        <el-col :lg="6" :md="12" :sm="12">
          <el-form-item
            :label="fields.timeFormat.label"
            :prop="fields.timeFormat.name"
            :required="fields.timeFormat.required"
          >
            <el-select
              :placeholder="i18n('common.select.placeholder')"
              v-model="model[fields.timeFormat.name]"
            >
              <i slot="prefix" class="icon-clock" />
              <el-option
                :key="option.id"
                :label="option.label"
                :value="option.id"
                v-for="option in fields.timeFormat.options"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { i18n } from '@shared/i18n';
import { FormSchema } from '@shared/form/form-schema';
import { SubpropertyModel } from '@modules/subproperty/subproperty-model';

import supportedCountries from '@enums/supportedCountries.json';
import { update } from 'lodash';

const { fields } = SubpropertyModel;

const formSchema = new FormSchema([
  fields.id,
  fields.propertyId,
  fields.name,
  fields.slug,
  fields.emails,
  fields.managers,
  fields.status,
  fields.access,
  fields.country,
  fields.region,
  fields.logo,
  fields.birthdateType,
  fields.dateFormat,
  fields.timeFormat,
  fields.owqloFeeFixed,
  fields.owqloFeePercentage,
]);

export default {
  name: 'app-subproperty-input',

  props: {
    subproperty: Object,    
    isPropertyNBA: {
      type: Boolean,
      default: false,
    },
    isMonoSubproperty: {
      type: Boolean
    },
    propertyCountry: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      rules: formSchema.rules(),
      model: null,
      initialModel: null,
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
    }),

    disableCountry() {
      if (this.isPropertyNBA) {
        update(
          this,
          'model.country',
          () => this.propertyCountry,
        );
      }
      return this.isPropertyNBA || this.isEditing;
    },
    showRegion() {
      return this.isPropertyNBA;
    },
    isEditing() {
      return !!this.id;
    },
    fields() {
      return fields;
    },
    supportedCountries() {
      return this.fields.country.options.filter(
        ({ id }) => {
          return supportedCountries.some(
            (countryId) => countryId === id,
          );
        },
      );
    },
    prefixStatus() {
      var status = '';
      if (this.model.status === 'enabled')
        return (status = 'icon-accept');
      if (this.model.status === 'disabled')
        return (status = 'icon-quit');
      return status;
    },
    enableOwqloFees() {
      return !this.isPropertyNBA;
    },
  },

  async created() {
    this.initialModel = Object.assign({}, this.subproperty);
    this.model = formSchema.initialValues(this.subproperty);
  },

  methods: {
    doReset() {
      this.model = formSchema.initialValues(
        this.initialModel,
      );
    },

    i18n(code) {
      return i18n(code);
    },
  },

  watch: {
    model: {
      deep: true,
      handler() {
        this.$emit(
          'update:subproperty',
          formSchema.cast(this.model),
        );
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.subproperty-input {
  &__subtitle {
    margin-bottom: 16px;
  }
  &__description {
    margin-bottom: 32px;
  }
}
</style>

<style>
.subproperty-input .el-form {
  padding: 0 0 0 0;
}
</style>